import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { useOptInNudgeResponse } from "@faire/retailer-visitor-shared/components/App/PopupOptInNudge/useOptInNudgeResponse";
import { OptInNudgeInput, optInOrigin } from "@faire/retailer-visitor-shared/components/Banners/OptInNudgeBanners/OptInNudgeInput";
import { useAppNudgeStore } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Button } from "@faire/web--source/slate/Button";
import { Opacity } from "@faire/web--source/slate/Color";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailersOptInNudgeExpandcollapseClick } from "@faire/web-api--source/events/retailers/click/optInNudgeExpandCollapse";
import { trackRetailersOptInNudgeDismissDismiss } from "@faire/web-api--source/events/retailers/dismiss/optInNudgeDismiss";
import { MARKETING_EMAIL_OPT_IN_COLLAPSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_EMAIL_OPT_IN_COLLAPSED";
import { MARKETING_EMAIL_OPT_IN_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_EMAIL_OPT_IN_DISMISSED";
import { MARKETING_SMS_OPT_IN_COLLAPSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_SMS_OPT_IN_COLLAPSED";
import { MARKETING_SMS_OPT_IN_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/MARKETING_SMS_OPT_IN_DISMISSED";
import { route as apparelCollectionProductBasedCollectionTokenRoute } from "@faire/web-api--source/routes/apparel-collection/product_based_collection_token";
import { route as brandbrandTokenRoute } from "@faire/web-api--source/routes/brand/brandToken";
import { route as cartRoute } from "@faire/web-api--source/routes/cart";
import { route as checkoutRoute } from "@faire/web-api--source/routes/checkout";
import { route as confirmIdentityRoute } from "@faire/web-api--source/routes/confirm-identity";
import { route as directbrandTokenOrAliasProductBasedCollectionproductBasedCollectionTokenRoute } from "@faire/web-api--source/routes/direct/brandTokenOrAlias/product-based-collection/product_based_collection_token";
import { route as pointOfSaleRoute } from "@faire/web-api--source/routes/point-of-sale";
import { route as productBasedCollectionProductBasedCollectionTokenRoute } from "@faire/web-api--source/routes/product-based-collection/product_based_collection_token";
import { route as retailerSettingsRoute } from "@faire/web-api--source/routes/retailer/settings";
import isUndefined from "lodash/isUndefined";
import React, { useEffect } from "react";
import styled from "styled-components";
var nudgeInteraction = {
    expand: "EXPAND",
    collapse: "COLLAPSE"
};
export var PopupType;
(function(PopupType) {
    PopupType["EMAIL"] = "EMAIL";
    PopupType["SMS"] = "SMS";
})(PopupType || (PopupType = {}));
var CollapsedNudge = function(param) {
    var nudgeData = param.nudgeData, handleOnExpand = param.handleOnExpand, handleOnDismiss = param.handleOnDismiss;
    if (!nudgeData.title) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(CollapsedWrapper, {
        onClick: handleOnExpand,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: nudgeData.title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                onClick: handleOnDismiss,
                children: /*#__PURE__*/ _jsx(Close, {
                    fontSize: getSpacing("2x")
                })
            })
        ]
    });
};
var ExpandedNudge = function(param) {
    var isSuccessful = param.isSuccessful, nudgeData = param.nudgeData, handleOnCollapse = param.handleOnCollapse, handleOnDismiss = param.handleOnDismiss, handleOnSuccess = param.handleOnSuccess, type = param.type, isMobile = param.isMobile;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSSR = useIsSSR();
    if (!nudgeData.title || !nudgeData.message || !nudgeData.image_url) {
        return null;
    }
    var imageUrl = nudgeData.image_url;
    if (isMobile && type === PopupType.SMS) {
        var _nudgeData_mobile_image_url;
        imageUrl = (_nudgeData_mobile_image_url = nudgeData.mobile_image_url) !== null && _nudgeData_mobile_image_url !== void 0 ? _nudgeData_mobile_image_url : imageUrl;
    }
    var optimizedBackgroundUrl = optimizeImageUrl({
        url: imageUrl
    }, isSSR, {
        width: 600
    });
    var title = !isSuccessful ? nudgeData.title : strictLocalize({
        id: "7h2Da2",
        defaultMessage: [
            {
                type: 0,
                value: "You\u2019re in!"
            }
        ]
    });
    var successMessage = strictLocalize({
        id: "V6TpSS",
        defaultMessage: [
            {
                type: 0,
                value: "Look for your first email soon."
            }
        ]
    });
    if (type === PopupType.SMS) {
        successMessage = strictLocalize({
            id: "0iC6bO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Look for your first SMS from us soon."
                }
            ]
        });
    }
    var message = !isSuccessful ? nudgeData.message : successMessage;
    return /*#__PURE__*/ _jsxs(ExpandedWrapper, {
        children: [
            /*#__PURE__*/ _jsx(CloseIconWrapper, {
                children: /*#__PURE__*/ _jsx(Button, {
                    "data-test-id": "nudgeCloseButton",
                    variant: "tertiary",
                    onClick: !isSuccessful ? handleOnCollapse : handleOnDismiss,
                    children: /*#__PURE__*/ _jsx(CloseIcon, {
                        fontSize: getSpacing("3x")
                    })
                })
            }),
            /*#__PURE__*/ _jsx(BannerImage, {
                src: optimizedBackgroundUrl,
                $isSSR: isSSR
            }),
            /*#__PURE__*/ _jsxs(Content, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        children: message
                    }),
                    !isSuccessful ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            }),
                            /*#__PURE__*/ _jsx(OptInNudgeInput, {
                                origin: optInOrigin.POPUP_PROMPT,
                                onSuccess: handleOnSuccess,
                                type: type,
                                savedPhoneNumber: nudgeData.phone_number
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "5x"
                            }),
                            /*#__PURE__*/ _jsx(CloseButton, {
                                onClick: handleOnDismiss,
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "WjfdZ4",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Close"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export var PopupOptInNudge = function() {
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var isMobile = useViewport().isMobile;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var _useOptInNudgeResponse = useOptInNudgeResponse(retailerToken !== null && retailerToken !== void 0 ? retailerToken : ""), nudgeResponse = _useOptInNudgeResponse.nudgeResponse, type = _useOptInNudgeResponse.type;
    var _useAppNudgeStore = _sliced_to_array(useAppNudgeStore([
        "hasAcknowledgedPopupOptInNudge"
    ]), 2), hasAcknowledgedPopupOptInNudge = _useAppNudgeStore[0].hasAcknowledgedPopupOptInNudge, setAppNudgeStore = _useAppNudgeStore[1];
    var _useMilestone = useMilestone(type === PopupType.EMAIL ? MARKETING_EMAIL_OPT_IN_DISMISSED : MARKETING_SMS_OPT_IN_DISMISSED), incrementCountPopupOptInNudgeDismissed = _useMilestone.incrementCount;
    var _useMilestone1 = useMilestone(type === PopupType.EMAIL ? MARKETING_EMAIL_OPT_IN_COLLAPSED : MARKETING_SMS_OPT_IN_COLLAPSED), incrementCountPopupOptInNudgeCollapsed = _useMilestone1.incrementCount;
    var _useState = _sliced_to_array(useState(true), 2), isCollapsed = _useState[0], setIsCollapsed = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSuccessful = _useState1[0], setIsSuccessful = _useState1[1];
    var _useState2 = _sliced_to_array(useState(undefined), 2), nudgeData = _useState2[0], setNudgeData = _useState2[1];
    useEffect(function() {
        setNudgeData(nudgeResponse === null || nudgeResponse === void 0 ? void 0 : nudgeResponse.opt_in_nudge_data);
        var collapsed = nudgeResponse === null || nudgeResponse === void 0 ? void 0 : nudgeResponse.collapsed;
        if (!isUndefined(collapsed)) {
            setIsCollapsed(collapsed);
        }
    }, [
        nudgeResponse === null || nudgeResponse === void 0 ? void 0 : nudgeResponse.collapsed,
        nudgeResponse === null || nudgeResponse === void 0 ? void 0 : nudgeResponse.opt_in_nudge_data
    ]);
    // requires exact match
    var routeMatcher = new RouteMatcher([
        brandbrandTokenRoute,
        confirmIdentityRoute,
        productBasedCollectionProductBasedCollectionTokenRoute,
        apparelCollectionProductBasedCollectionTokenRoute,
        directbrandTokenOrAliasProductBasedCollectionproductBasedCollectionTokenRoute
    ]);
    var isExcludedRoutes = function() {
        return !!routeMatcher.match(pathname) || pathname.startsWith(cartRoute) || pathname.startsWith(checkoutRoute) || pathname.startsWith(retailerSettingsRoute) || pathname.startsWith(pointOfSaleRoute);
    };
    var shouldShowPopupNudge = !(isUndefined(nudgeData) || isExcludedRoutes() || hasAcknowledgedPopupOptInNudge);
    if (!shouldShowPopupNudge) {
        return null;
    }
    var handleOnClickOutside = function() {
        if (isCollapsed) {
            return;
        }
        if (isSuccessful) {
            handleOnDismiss();
        }
        handleOnCollapse();
    };
    var handleOnCollapse = function() {
        incrementCountPopupOptInNudgeCollapsed();
        trackRetailersOptInNudgeExpandcollapseClick(nudgeInteraction.collapse);
        setIsCollapsed(true);
    };
    var handleOnExpand = function() {
        trackRetailersOptInNudgeExpandcollapseClick(nudgeInteraction.expand);
        setIsCollapsed(false);
    };
    var handleOnDismiss = function() {
        setAppNudgeStore({
            hasAcknowledgedPopupOptInNudge: true
        });
        // dismissals when opt-in via nudge is successful shouldn't count
        if (!isSuccessful) {
            incrementCountPopupOptInNudgeDismissed();
            trackRetailersOptInNudgeDismissDismiss();
        }
    };
    var handleOnSuccess = function() {
        setIsSuccessful(true);
    };
    return /*#__PURE__*/ _jsx(NudgeWrapper, {
        tabIndex: -1,
        onClickOutside: handleOnClickOutside,
        children: isCollapsed ? /*#__PURE__*/ _jsx(CollapsedNudge, {
            nudgeData: nudgeData,
            handleOnExpand: handleOnExpand,
            handleOnDismiss: handleOnDismiss
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                isMobile ? /*#__PURE__*/ _jsx(OpaqueBackground, {
                    onClick: handleOnClickOutside
                }) : null,
                /*#__PURE__*/ _jsx(ExpandedNudge, {
                    isSuccessful: isSuccessful,
                    nudgeData: nudgeData,
                    handleOnCollapse: handleOnCollapse,
                    handleOnDismiss: handleOnDismiss,
                    handleOnSuccess: handleOnSuccess,
                    type: type,
                    isMobile: isMobile
                })
            ]
        })
    });
};
var NudgeWrapper = styled(ClickOutside).withConfig({
    componentId: "sc-2d44881c-0"
})([
    "position:fixed;right:",
    ';bottom:0px;z-index:20;> div{position:relative;top:unset;left:unset;right:unset;bottom:"unset";}button{display:flex;}&&&{@media print{display:none;}}',
    "{min-width:350px;max-width:432px;}",
    "{right:0px;left:0px;}"
], getSpacing("3x"), responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile);
var CollapsedWrapper = styled(Row).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-2d44881c-1"
})([
    "cursor:pointer;padding:",
    ";background-color:",
    ";box-shadow:0px 2px 10px ",
    "",
    ";",
    "{width:fit-content;}",
    "{border-top:1px solid ",
    ";box-shadow:0px;}"
], getSpacing("2x"), Decorative.tint.neutral, Core.surface.default, Opacity.O_15, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile, Core.border.muted);
var OpaqueBackground = styled.div.withConfig({
    componentId: "sc-2d44881c-2"
})([
    "height:100vh;background-color:",
    ";opacity:0.5;"
], Core.surface.enabled);
var ExpandedWrapper = styled(Column).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-2d44881c-3"
})([
    "background:",
    ";box-shadow:0px 2px 10px ",
    "",
    ";"
], Decorative.tint.neutral, Core.surface.default, Opacity.O_15);
var CloseIcon = styled(Close).withConfig({
    componentId: "sc-2d44881c-4"
})([
    "height:",
    ";width:",
    ";padding:10px;background-color:",
    ";border-radius:100px;"
], getSpacing("5x"), getSpacing("5x"), Core.surface.subdued);
var CloseIconWrapper = styled(Row).attrs({
    justify: "end"
}).withConfig({
    componentId: "sc-2d44881c-5"
})([
    "z-index:1;position:absolute;right:0;margin:",
    ";"
], getSpacing("2x"));
var BannerImage = styled.img.withConfig({
    componentId: "sc-2d44881c-6"
})([
    "flex-shrink:0;width:100%;height:196px;object-fit:cover;object-position:bottom;"
]);
var Content = styled(Column).withConfig({
    componentId: "sc-2d44881c-7"
})([
    "width:100%;padding:",
    ";"
], getSpacing("3x", "4x"));
var CloseButton = styled(Button).withConfig({
    componentId: "sc-2d44881c-8"
})([
    "width:fit-content;min-width:86px;"
]);
